module.exports = __webpack_public_path__ + "img/ys.1b94f209.png";